const MaintenanceImageDark = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 282 316" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_4928_65610)">
      <path
        d="M159.868 243.483C227.319 243.483 282 188.978 282 121.742C282 54.5056 227.319 0 159.868 0C92.4158 0 37.7353 54.5056 37.7353 121.742C37.7353 188.978 92.4158 243.483 159.868 243.483Z"
        fill="#1B1B1B"
      />
      <path
        d="M239.679 54.4427H15.9496C15.4699 54.4324 15.0892 54.0365 15.0995 53.5583C15.1095 53.0944 15.4843 52.7208 15.9496 52.7109H239.679C240.159 52.7211 240.54 53.1171 240.529 53.5953C240.519 54.0591 240.145 54.4327 239.679 54.4427Z"
        fill="#A7A7A7"
      />
      <path
        d="M163.433 83.6243H101.585C96.9396 83.6243 93.1737 87.3782 93.1737 92.0088V92.0088C93.1737 96.6394 96.9396 100.393 101.585 100.393H163.433C168.078 100.393 171.844 96.6394 171.844 92.0088C171.844 87.3782 168.078 83.6243 163.433 83.6243Z"
        fill="#595959"
      />
      <path
        d="M61.6311 117.162H203.387C208.032 117.162 211.798 120.916 211.798 125.547C211.798 130.177 208.032 133.931 203.387 133.931H61.6311C56.9857 133.931 53.2198 130.177 53.2198 125.547C53.2198 120.916 56.9857 117.162 61.6311 117.162Z"
        fill="#595959"
      />
      <path
        d="M61.6311 150.7H203.387C208.032 150.7 211.798 154.454 211.798 159.084C211.798 163.715 208.032 167.469 203.387 167.469H61.6311C56.9857 167.469 53.2198 163.715 53.2198 159.084C53.2198 154.454 56.9857 150.7 61.6311 150.7Z"
        fill="#595959"
      />
      <path
        d="M44.0642 315.263L43.7306 315.23C32.4114 314.066 22.1789 307.998 15.7515 298.638C13.991 296.029 12.5669 293.211 11.5129 290.248L11.4116 289.965L11.7115 289.941C15.2923 289.654 18.9709 289.048 20.605 288.76L10.0676 285.201L10.0024 284.889C9.37772 281.964 10.6016 278.954 13.0935 277.287C15.5921 275.54 18.9055 275.484 21.462 277.146C22.6093 277.876 23.8093 278.6 24.9696 279.3C28.9573 281.704 33.0808 284.19 36.1723 287.592C40.8602 292.854 42.915 299.943 41.7644 306.886L44.0642 315.263Z"
        fill="#1B1B1B"
      />
      <path
        d="M82.3673 310.039L87.5603 310.039L90.0313 290.07L82.3658 290.071L82.3673 310.039Z"
        fill="#A0616A"
      />
      <path
        d="M82.1841 315.439L98.1548 315.439V315.238C98.1545 311.816 95.3715 309.041 91.9385 309.041L89.0209 306.835L83.578 309.042L82.1838 309.042L82.1841 315.439Z"
        fill="#043952"
      />
      <path
        d="M40.7466 295.7L44.9005 298.807L58.8991 284.312L52.7675 279.727L40.7466 295.7Z"
        fill="#A0616A"
      />
      <path
        d="M37.3487 299.911L50.124 309.464L50.2452 309.303C52.3053 306.566 51.7493 302.682 49.0033 300.628L47.9977 297.118L42.3155 295.627L41.2003 294.793L37.3487 299.911Z"
        fill="#043952"
      />
      <path
        d="M58.0103 216.332C58.0103 216.332 58.297 224.128 58.6586 230.379C58.7179 231.405 56.3082 232.518 56.3706 233.634C56.412 234.374 56.8649 235.093 56.907 235.865C56.9514 236.679 56.326 237.4 56.3706 238.242C56.4141 239.065 57.1275 240.008 57.1705 240.851C57.6337 249.914 59.3125 260.764 57.6314 263.797C56.8029 265.291 46.2426 286 46.2426 286C46.2426 286 52.1264 294.797 53.8075 291.865C56.0279 287.992 73.1401 269.871 73.1401 266.411C73.1401 262.955 77.099 237.052 77.099 237.052L79.8595 252.381L81.1253 255.418L80.7276 257.201L81.5455 259.607L81.5897 261.989L82.3861 266.411C82.3861 266.411 79.9906 300.863 81.3396 301.823C82.6929 302.786 89.245 304.516 90.0183 302.786C90.7874 301.056 95.7935 266.83 95.7935 266.83C95.7935 266.83 96.6004 251.145 97.4746 236.566C97.525 235.72 98.1218 234.698 98.1681 233.864C98.2227 232.896 97.8445 231.64 97.8948 230.701C97.9495 229.625 98.4286 228.866 98.4748 227.836C98.8321 219.872 96.8267 210.174 96.1879 209.219C94.2588 206.337 92.5231 204.033 92.5231 204.033C92.5231 204.033 66.5408 195.523 59.5979 204.17L58.0103 216.332Z"
        fill="#043952"
      />
      <path
        d="M83.924 136.17L73.6241 134.117L68.8175 140.619C59.8486 149.41 59.7135 157.168 61.3146 169.604V187.058L60.1558 198.759C60.1558 198.759 56.0535 207.312 60.2846 209.303C64.5157 211.295 92.3076 211.125 94.961 210.33C97.6145 209.535 95.3145 208.559 94.6177 204.854C93.3088 197.895 94.1843 201.252 94.2744 199.036C95.5659 167.252 92.5578 154.204 92.2523 150.774L87.0141 141.304L83.924 136.17Z"
        fill="#0889C6"
      />
      <path
        d="M138.211 161.797C137.138 163.824 134.619 164.601 132.585 163.531C132.368 163.417 132.161 163.284 131.968 163.133L109.724 177.212L109.788 169.547L131.396 157.047C132.936 155.327 135.582 155.176 137.308 156.711C138.752 157.994 139.125 160.097 138.211 161.797Z"
        fill="#A0616A"
      />
      <path
        d="M75.7917 145.047L73.2593 144.78C70.9194 144.538 68.6236 145.537 67.2107 147.411C66.6695 148.123 66.2808 148.937 66.0687 149.804L66.0672 149.811C65.432 152.421 66.4283 155.156 68.5955 156.752L77.342 163.18C83.4801 171.447 95.0159 176.932 108.547 181.388L129.581 168.367L122.141 159.386L107.714 167.093L86.2699 150.546L86.2576 150.536L78.0958 145.294L75.7917 145.047Z"
        fill="#0889C6"
      />
      <path
        d="M80.4438 131.129C87.0774 131.129 92.455 125.768 92.455 119.156C92.455 112.544 87.0774 107.183 80.4438 107.183C73.8102 107.183 68.4326 112.544 68.4326 119.156C68.4326 125.768 73.8102 131.129 80.4438 131.129Z"
        fill="#A0616A"
      />
      <path
        d="M80.7213 131.131C80.6244 131.134 80.5274 131.137 80.4304 131.139C80.3889 131.247 80.3442 131.353 80.2925 131.457L80.7213 131.131Z"
        fill="#2F2E41"
      />
      <path
        d="M84.0176 119.488C84.0365 119.606 84.0653 119.722 84.1038 119.835C84.0879 119.717 84.059 119.6 84.0176 119.488Z"
        fill="#2F2E41"
      />
      <path
        d="M92.6083 107.695C92.1139 109.226 91.6726 107.285 90.0463 107.634C88.0898 108.054 85.8131 107.91 84.2109 106.714C81.8237 104.968 78.73 104.498 75.9293 105.456C73.1878 106.423 68.5949 107.104 67.8806 109.914C67.6323 110.891 67.5337 111.951 66.9318 112.76C66.4056 113.468 65.575 113.872 64.8805 114.416C62.5353 116.256 64.3278 121.481 65.4377 124.242C66.5477 127.003 69.0938 129.015 71.893 130.045C74.6015 131.042 77.5411 131.218 80.4304 131.139C80.933 129.84 80.7159 128.339 80.3012 126.993C79.8523 125.535 79.1876 124.127 79.0001 122.614C78.8126 121.1 79.2244 119.381 80.4976 118.535C81.6679 117.758 83.5724 118.231 84.0177 119.488C83.7579 117.917 85.3547 116.396 87.0013 116.129C88.7691 115.842 90.5368 116.478 92.2996 116.795C94.0623 117.111 93.4366 109.714 92.6083 107.695Z"
        fill="#993D00"
      />
      <path
        d="M159.784 138.961C160.904 125.476 150.844 113.638 137.315 112.522C123.786 111.406 111.91 121.434 110.791 134.92C109.671 148.405 119.731 160.243 133.26 161.359C146.789 162.475 158.664 152.447 159.784 138.961Z"
        fill="#FF8533"
      />
      <path
        d="M141.744 126.731L135.287 133.167L128.83 126.731C127.785 125.689 126.091 125.689 125.045 126.731C124 127.773 124 129.462 125.045 130.504L131.502 136.94L125.045 143.377C124.001 144.419 124.003 146.109 125.049 147.149C126.094 148.189 127.786 148.189 128.83 147.149L135.287 140.713L141.744 147.149C142.79 148.19 144.485 148.189 145.529 147.146C146.572 146.104 146.572 144.418 145.529 143.377L139.072 136.94L145.529 130.504C146.574 129.462 146.574 127.773 145.529 126.731C144.484 125.689 142.789 125.689 141.744 126.731Z"
        fill="white"
      />
      <path
        d="M125.601 116.347C126.326 118.522 125.144 120.872 122.961 121.594C122.728 121.671 122.489 121.727 122.246 121.762L117.039 147.509L111.534 142.156L117.445 117.96C117.265 115.662 118.988 113.654 121.294 113.475C123.223 113.325 125.003 114.512 125.601 116.347Z"
        fill="#A0616A"
      />
      <path
        d="M70.2622 149.649L68.3154 151.285C66.5203 152.801 65.6541 155.144 66.0331 157.458C66.1732 158.339 66.4936 159.183 66.9745 159.936L66.9785 159.941C68.4281 162.205 71.0979 163.382 73.7534 162.928L84.4619 161.087C94.6963 162.395 106.653 157.895 119.247 151.246L124.382 127.103L112.73 126.236L108.322 141.949L81.4968 145.918L81.481 145.92L72.036 148.162L70.2622 149.649Z"
        fill="#0889C6"
      />
      <path
        d="M131.238 315.853L0.570674 316C0.254481 315.999 -0.00102111 315.743 3.06834e-06 315.427C0.00101763 315.114 0.255918 314.86 0.570674 314.859L131.238 314.711C131.554 314.712 131.81 314.969 131.809 315.284C131.807 315.598 131.553 315.852 131.238 315.853Z"
        fill="#222222"
      />
      <path
        d="M27.3004 43.474C29.5461 43.474 31.3666 41.6188 31.3666 39.3304C31.3666 37.042 29.5461 35.1868 27.3004 35.1868C25.0547 35.1868 23.2341 37.042 23.2341 39.3304C23.2341 41.6188 25.0547 43.474 27.3004 43.474Z"
        fill="#4A4A4A"
      />
      <path
        d="M41.3474 43.474C43.5931 43.474 45.4136 41.6188 45.4136 39.3304C45.4136 37.042 43.5931 35.1868 41.3474 35.1868C39.1016 35.1868 37.2811 37.042 37.2811 39.3304C37.2811 41.6188 39.1016 43.474 41.3474 43.474Z"
        fill="#4A4A4A"
      />
      <path
        d="M55.3944 43.474C57.6402 43.474 59.4607 41.6188 59.4607 39.3304C59.4607 37.042 57.6402 35.1868 55.3944 35.1868C53.1487 35.1868 51.3282 37.042 51.3282 39.3304C51.3282 41.6188 53.1487 43.474 55.3944 43.474Z"
        fill="#4A4A4A"
      />
      <path
        d="M71.4118 42.6053C71.2869 42.6053 71.1622 42.5571 71.068 42.4612L68.3244 39.6654C68.1415 39.4791 68.1415 39.1815 68.3244 38.9952L71.068 36.1997C71.2542 36.0106 71.559 36.0075 71.748 36.1922C71.9379 36.3773 71.9412 36.6808 71.7555 36.8699L69.3407 39.3303L71.7555 41.7909C71.9412 41.98 71.9379 42.2836 71.748 42.4687C71.6545 42.5599 71.5331 42.6053 71.4118 42.6053Z"
        fill="#4A4A4A"
      />
      <path
        d="M76.0222 42.6053C75.9008 42.6053 75.7794 42.5599 75.686 42.4687C75.496 42.2835 75.4928 41.9802 75.6785 41.7909L78.093 39.3303L75.6785 36.8699C75.4928 36.6808 75.496 36.3773 75.686 36.1922C75.8754 36.0068 76.1802 36.0103 76.3659 36.1996L79.1094 38.9952C79.2923 39.1814 79.2923 39.4791 79.1094 39.6654L76.3659 42.4612C76.2718 42.5571 76.1471 42.6053 76.0222 42.6053Z"
        fill="#4A4A4A"
      />
      <path
        d="M219.556 35.6666H214.455C213.873 35.6666 213.402 36.1363 213.402 36.7162V41.8064C213.402 42.3863 213.873 42.856 214.455 42.856H219.556C220.138 42.856 220.614 42.3863 220.614 41.8064V36.7162C220.614 36.1363 220.138 35.6666 219.556 35.6666Z"
        fill="#4A4A4A"
      />
      <path
        d="M207.055 35.6666H201.953C201.371 35.6666 200.9 36.1363 200.9 36.7162V41.8064C200.9 42.3863 201.371 42.856 201.953 42.856H207.055C207.637 42.856 208.113 42.3863 208.113 41.8064V36.7162C208.113 36.1363 207.637 35.6666 207.055 35.6666Z"
        fill="#4A4A4A"
      />
      <path
        d="M231.337 35.9062H226.235C225.653 35.9062 225.182 36.3759 225.182 36.9558V42.046C225.182 42.626 225.653 43.0957 226.235 43.0957H231.337C231.919 43.0957 232.395 42.626 232.395 42.046V36.9558C232.395 36.3759 231.919 35.9062 231.337 35.9062Z"
        fill="#4A4A4A"
      />
      <path
        d="M154.441 37.8425H113.661C112.949 37.8425 112.377 38.4177 112.377 39.1223C112.377 39.8269 112.949 40.402 113.661 40.402H154.441C155.148 40.402 155.725 39.8268 155.725 39.1223C155.725 38.4177 155.148 37.8425 154.441 37.8425Z"
        fill="#4A4A4A"
      />
    </g>
    <defs>
      <clipPath id="clip0_4928_65610">
        <rect width="282" height="316" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default MaintenanceImageDark
